<template>
  <section class="content">
    <loader v-show="loading"></loader>
    <vuetable
      v-show="!loading"
      v-on:table-delete-request="deleteEntity"
      v-on:table-edit-request="handleEdit"
      :showEdit="true"
      :showDelete="true"
      :tableData="tableData"
      :tableTitle="'Financial Codes'"
      :fields="[{ header: 'Name', prop: 'name' }, { header: 'Code', prop: 'code' }]"
      v-on:pages-remaining="loadMore"
      :maxItems="maxValue"     
    ></vuetable>
  </section>
</template>
<script>
  import vuetable from '../../../helpers/VueTable.vue'
  import Loader from '../../../helpers/Loader.vue'
  import AdminSearchResults from '../../mixins/AdminSearchResultsMixin.js'
  export default {
    name: 'FinancialSearchResults',
    components: {
      vuetable: vuetable,
      Loader
    },
    mixins: [ AdminSearchResults ],
    data () {
      return {
        loading: false,
        tableData: [],
        entityName: 'financial-code',
        editEntityScreen: 'Admin - Edit/View Financial Code'
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// FinancialCodeSearchResults.vue?c50dd3a8